import http from '@/biz/http.mjs'

export const apiBaseConfig = {
    read: () => http.get('/basConfig'),
}
